import { vastTags } from './vast-tags.js';
import { vpaidTags } from './vpaid-tags.js';
import { simidTags } from './simid-tags.js';
import { errorTags } from './error-tags.js';

const allPresets = [
  ...vastTags,
  ...vpaidTags,
  ...simidTags,
  ...errorTags,
];

export function getAllPresets() {
  return allPresets;
}

export function getPresetsByCategory(category) {
  return allPresets.filter(p => p.category === category);
}

export function getPresetByName(name) {
  return allPresets.find(p => p.name === name) || null;
}

export function getCategories() {
  return [...new Set(allPresets.map(p => p.category))];
}
